// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"7374e502","165":"67d28007","321":"8f42ecba","370":"c23443b0","510":"92a2f3ec","535":"d14ad306","551":"4ed11182"}[chunkId] + ".chunk.js";
};